import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    console.log('CartDrawerComponent connected');
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
  #handleCartAdd = () => {
    this.showDialog();
    console.log('forcing open cart');
  };
   */

#handleCartAdd = (event) => {
  const limitedReleaseVariantId = '45252817223862';
  const addedVariantId = String(event.detail?.sourceId ?? '');

  if (addedVariantId === limitedReleaseVariantId) {
    const modal = document.getElementById(
      'limited-release-shipping-modal'
    );

    const popupAlreadyShown = sessionStorage.getItem(
      'limitedReleaseShippingPopupShown'
    );

    if (
      modal &&
      typeof modal.showModal === 'function' &&
      !popupAlreadyShown
    ) {
      sessionStorage.setItem(
        'limitedReleaseShippingPopupShown',
        'true'
      );

      modal.showModal();
      return;
    }
  }

  this.showDialog();
};

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}